// extracted by mini-css-extract-plugin
export var dropdown = "_w3-0";
export var imageWrapper = "_w3-3";
export var itemNameContainer = "_w3-1";
export var productImage = "_w3-2";
export var spinnerWrapper = "_w3-4";